const ADMIN_ROLE_CONFIG = {
  platform_admin: {
    role: "platform_admin",
    routeRole: "platform",
    homePath: "/platform/dashboard",
    tokenKey: "platform_admin_token"
  },
  tenant_admin: {
    role: "tenant_admin",
    routeRole: "supplier",
    homePath: "/supplier/dashboard",
    tokenKey: "tenant_admin_token"
  },
  school_admin: {
    role: "school_admin",
    routeRole: "school",
    homePath: "/school/dashboard",
    tokenKey: "school_admin_token"
  }
};

function getStorage(storage) {
  if (storage) {
    return storage;
  }

  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }

  return null;
}

export function resolveAdminRoleConfig(role) {
  return ADMIN_ROLE_CONFIG[role] || null;
}

export function persistAdminLoginSession(storage, payload) {
  const targetStorage = getStorage(storage);
  const roleConfig = resolveAdminRoleConfig(payload?.role);

  if (!targetStorage || !roleConfig || !payload?.token) {
    return null;
  }

  Object.values(ADMIN_ROLE_CONFIG).forEach((item) => {
    if (item.tokenKey !== roleConfig.tokenKey) {
      targetStorage.removeItem?.(item.tokenKey);
    }
  });

  targetStorage.setItem(roleConfig.tokenKey, payload.token);
  targetStorage.setItem("current_admin_role", roleConfig.role);
  targetStorage.removeItem?.("current_admin_password_set");
  targetStorage.removeItem?.("current_admin_password_set_at");

  if (payload.user) {
    targetStorage.setItem("current_admin_user", JSON.stringify(payload.user));
  }

  return roleConfig;
}

export function readCurrentAdminRole(storage) {
  const targetStorage = getStorage(storage);
  return targetStorage?.getItem("current_admin_role") || "";
}

export function readCurrentAdminRoleConfig(storage) {
  const targetStorage = getStorage(storage);
  const currentAdminRole = readCurrentAdminRole(targetStorage);
  const roleConfig = resolveAdminRoleConfig(currentAdminRole);

  if (roleConfig && targetStorage?.getItem(roleConfig.tokenKey)) {
    return roleConfig;
  }

  return Object.values(ADMIN_ROLE_CONFIG)
    .find((item) => targetStorage?.getItem(item.tokenKey)) || null;
}

export function readCurrentAdminToken(storage) {
  const targetStorage = getStorage(storage);
  const roleConfig = readCurrentAdminRoleConfig(targetStorage);
  if (!roleConfig) {
    return "";
  }
  return targetStorage?.getItem(roleConfig.tokenKey) || "";
}

export function persistAdminPasswordStatus(storage, payload) {
  const targetStorage = getStorage(storage);
  if (!targetStorage) {
    return;
  }

  targetStorage.setItem("current_admin_password_set", payload?.passwordSet ? "true" : "false");
  if (payload?.passwordSetAt) {
    targetStorage.setItem("current_admin_password_set_at", payload.passwordSetAt);
    return;
  }

  targetStorage.removeItem?.("current_admin_password_set_at");
}

export function clearAdminLoginSession(storage) {
  const targetStorage = getStorage(storage);
  if (!targetStorage) {
    return;
  }

  Object.values(ADMIN_ROLE_CONFIG).forEach((item) => {
    targetStorage.removeItem?.(item.tokenKey);
  });

  targetStorage.removeItem?.("current_admin_role");
  targetStorage.removeItem?.("current_admin_user");
  targetStorage.removeItem?.("current_admin_password_set");
  targetStorage.removeItem?.("current_admin_password_set_at");
}

export function readAdminPasswordStatus(storage) {
  const targetStorage = getStorage(storage);
  const raw = targetStorage?.getItem("current_admin_password_set");

  if (raw !== "true" && raw !== "false") {
    return {
      passwordSet: null,
      passwordSetAt: null
    };
  }

  return {
    passwordSet: raw === "true",
    passwordSetAt: targetStorage?.getItem("current_admin_password_set_at") || null
  };
}

export function readCurrentAdminUser(storage) {
  const targetStorage = getStorage(storage);
  const raw = targetStorage?.getItem("current_admin_user");
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (_error) {
    return null;
  }
}
